import React from "react";
import { useTheme } from '@mui/material/styles';
import { useForm, FormProvider } from 'react-hook-form';
import { Grid, Typography, Box, Button } from "@mui/material";
import { object, string } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';

import ToastMessage from "../../../components/layout/ToastMessage";
import FormInput from "../../../components/form/FormInput";
import { forgotPassword } from "../../../redux/actions/auth";

const forgotPasswordSchema = object({
  email: string().min(1, 'Email is required').email('Email is invalid'),
});

function ForgotPasswordForm() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const defaultValues = { email: '' };

  const methods = useForm({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues,
  });

  // ? Submit Handler
  const onSubmitHandler = async (data) => {
    const { result } = await dispatch(forgotPassword(data));
    if (result) {
      toast(<ToastMessage title="Recovery Email Sent" message="Please check your email to reset your password." />, {closeButton: false});
      navigate('/login');
    }
  };

  return (
    <Grid
      justifyContent='center'
      sx={{
        width: { sm: '550px' },
        minHeight: '300px',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d',
        borderRadius: '0.625rem',
        padding: { xs: 4, md: '4rem' }
      }}
    >
      <FormProvider {...methods}>
        <Box
          display='flex'
          flexDirection='column'
          component='form'
          noValidate
          autoComplete='off'
          onSubmit={methods.handleSubmit(onSubmitHandler)}
        >
          <Typography sx={{ fontWeight: 800, textAlign: 'center', fontSize: '1.5rem', lineHeight: '1.2' }}>Forgot Password</Typography>
          <Typography sx={{ mt: 1, mb: 2, fontSize: '0.85rem', fontWeight: 400, lineHeight: '1.3', textAlign: 'center', color: theme.palette.mode === 'light' ? '#aaaaaa' : '#565674' }}>
            Enter your account email below for instructions to reset your password.
          </Typography>
          <FormInput
            placeholder='Email'
            type='email'
            name='email'
            required
            sx={{ mt: 4 }}
          />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            sx={{ mt: 4, color: '#fff', fontWeight: 600, height: '2.5rem', textTransform: 'none' }}
          >
            Send Reset Link
          </Button>
          <Grid container justifyContent='center'>
            <Typography sx={{ mt: 2, fontSize: '0.8rem', fontWeight: 600, textAlign: 'center' }}><span style={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>Need help?</span> <Link to='mailto:team@clientl.app'>Contact us</Link></Typography>
          </Grid>
        </Box>
      </FormProvider>
    </Grid>
  );
}

export default ForgotPasswordForm;
